import ReusebleTable from "../../../../../components/ReusebleTable";
import { CreditHistoryColumns } from "../model/creditHistoryTypes";
import { useCreditHistoryViewModel } from "../viewmodel/creditHistoryViewmodel";
import { format } from "date-fns";
import TopUpButton from "../../topup/view/topupButton";
import TopUpDialog from "../../topup/view/topupView";
import { useState } from "react";
import { canUseTopUp } from "../model/topUpEligibility";
import TablePagination from "../../../JobManagement/Components/TablePagination";

export const CreditHistoryView = () => {
  const { state, dispatch } = useCreditHistoryViewModel();
  const [isTopUpOpen, setIsTopUpOpen] = useState(false);
  console.log("trialStatus", state.trialStatus);
  console.log(
    "is_trial",
    state.trialStatus?.is_trial,
    "has_subscription",
    state.trialStatus?.has_subscription,
  );
  const today = new Date().toISOString().split("T")[0];
  const transactionTypeStyles: Record<string, string> = {
    SUBSCRIPTION: "bg-info/15 text-info",
    CREDIT: "bg-success/15 text-success",
    DEBIT: "bg-destructive/15 text-destructive",
    REFUND: "bg-warning/15 text-warning",
    TRANSFER: "bg-muted text-muted-foreground",
    USAGE: "bg-blue-100 text-blue-800",
  };

  function formatBalance(value: number) {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  }
  function AmountCell({ amount }: { amount: number }) {
    const isPositive = amount >= 0;
    return (
      <div
        className={`flex items-center gap-1 font-mono text-sm font-semibold ${
          isPositive ? "text-green-600" : "text-red-600"
        }`}
      >
        {amount}
      </div>
    );
  }
  if (state.loading) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/4 mb-6"></div>
          <div className="space-y-4">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="bg-white rounded-lg shadow p-6">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  const disableTopUp = !canUseTopUp(state.trialStatus);
  return (
    <div className="w-full space-y-2">
      <div className=" mb-2">
        <div className="flex flex-col sm:flex-row sm:flex-wrap gap-4 sm:items-end justify-end">
          <TopUpButton
            onClick={() => setIsTopUpOpen(true)}
            disabled={disableTopUp}
          />
          <TopUpDialog
            isOpen={isTopUpOpen}
            onClose={() => setIsTopUpOpen(false)}
            onSubmit={(amount) => {
              console.log("Top up submitted:", amount);
              setIsTopUpOpen(false);
            }}
          />
          <div className="flex flex-col ">
            <label className="text-sm font-medium text-gray-700 mb-1">
              Start Date
            </label>
            <input
              placeholder="DD/MM/YYYY"
              type="date"
              value={state.startDate}
              max={today}
              onChange={(e) =>
                dispatch({ type: "SET_START_DATE", payload: e.target.value })
              }
              className="border border-gray-300 rounded-md p-2 w-full sm:w-48"
            />
          </div>

          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">
              End Date
            </label>
            <input
              placeholder="DD/MM/YYYY"
              type="date"
              value={state.endDate}
              min={state.startDate || undefined}
              onChange={(e) =>
                dispatch({ type: "SET_END_DATE", payload: e.target.value })
              }
              className="border border-gray-300 rounded-md p-2 w-full sm:w-48"
            />
          </div>

          <div className="flex items-end gap-2 w-full sm:w-auto">
            <button
              onClick={() => {
                dispatch({ type: "SET_PAGE", payload: 1 });
                dispatch({ type: "SET_SEARCHED" });
              }}
              disabled={!state.startDate || !state.endDate}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:opacity-50 transition"
            >
              {state.loading ? "Searching..." : "Search"}
            </button>

            {state.isSearched && (
              <button
                onClick={() => {
                  dispatch({ type: "RESET_FILTER" });
                }}
                className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600 transition"
              >
                Reset
              </button>
            )}
          </div>
        </div>
      </div>
      <ReusebleTable
        headers={CreditHistoryColumns.map((col) => col.title)}
        data={state.creditHistory}
        currentPage={state.currentPage}
        pageSize={state.pageSize}
        total={state.total}
        showPagination={false}
        onPageChange={(page) => {
          dispatch({ type: "SET_PAGE", payload: page });
          /// getCreditHistoryData();
        }}
        renderRow={(txn) => (
          <>
            <td className="p-4 text-sm text-gray-500 whitespace-nowrap ">
              {txn.action_name}
            </td>

            <td className="p-2">
              <span
                className={`px-2 py-1 text-xs font-medium rounded-full ${
                  transactionTypeStyles[txn.transaction_type] ||
                  "bg-gray-100 text-gray-600"
                }`}
              >
                {txn.transaction_type}
              </span>
            </td>
            <td className="p-4 text-sm text-gray-500 whitespace-nowrap ">
              <AmountCell amount={txn.amount} />
            </td>
            <td className="p-4 text-sm text-gray-500 whitespace-nowrap ">
              {formatBalance(txn.balance_after)}
            </td>
            <td
              className="p-4 text-sm max-w-[320px] whitespace-normal break-words text-foreground"
              title={txn.description}
            >
              {txn.description}
            </td>

            <td className="text-sm text-gray-500 whitespace-nowrap p-6">
              {format(new Date(txn.created_at + "Z"), "dd MMM yyyy")}
              <span className="ml-1 text-xs text-gray-400">
                {format(new Date(txn.created_at + "Z"), "hh:mm a")}
              </span>
            </td>
          </>
        )}
      ></ReusebleTable>
      {state.total > state.pageSize && (
        <TablePagination
          currentPage={state.currentPage}
          totalCount={state.total}
          rowsPerPage={state.pageSize}
          onPageChange={(page) => dispatch({ type: "SET_PAGE", payload: page })}
          onRowsPerPageChange={(rows) =>
            dispatch({ type: "SET_PAGE_SIZE", payload: rows })
          }
        />
      )}
    </div>
  );
};
